import React, { useState } from "react";
import getStyles from "../tool/Style";
import { Typography, TextField, Button, Grid, Box } from "@mui/material";
import HowToRegIcon from '@mui/icons-material/HowToReg';

import { loginUsuario } from "../../actions/UsuarioAction";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../contexto/store";

import { LogoIcon } from "../Tool";
import Notice from "../../componentes/notice/Notice";
import { useTheme } from "@mui/material/styles";

const Login = () => {
  const theme = useTheme();
  const [{ usuarioSesion }, dispatch] = useStateValue();
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState({
    Email: "",
    Password: "",
  });

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setUsuario((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

  const loginUsuarioBoton = (e) => {
    e.preventDefault();
    loginUsuario(usuario, dispatch).then((response) => {
      if (response.status === 200) {
        window.localStorage.setItem("token_seguridad", response.data.token);
        navigate("/dashboard");
      } else {
        const backendMsg = response?.data?.errors?.message;
        dispatch({
          type: "OPEN_SNACKBAR",
          openMensaje: {
            open: true,
            mensaje: backendMsg || "Las credenciales del usuario son incorrectas",
          },
        });
      }
    });
  };

  const clases = getStyles(theme);

  return (
    <Box
      component="main"
      sx={{
        background: 'linear-gradient(135deg, #F5F7FA 0%, #E0F2F1 100%)',
        display: 'flex',
        justifyContent: 'center',
        height: '100vh',
        alignItems: 'center',
        p: 2
      }}
    >
      <Box sx={{
        ...clases.paperUno,
        maxWidth: 1000,
        bgcolor: 'background.paper',
        borderRadius: 4,
        overflow: 'hidden',
        boxShadow: '0px 20px 40px rgba(0,0,0,0.1)'
      }}>
        <Grid container sx={{ height: '70vh', minHeight: 600 }}>
          <Grid
            sx={{
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: 'background.default'
            }}
          >
            <Box sx={{ mb: 2, textAlign: 'center' }}>
                <LogoIcon color="primary" sx={{ fontSize: '4rem' }} />
                <Typography variant="h5" sx={{ fontWeight: 800, mt: 2 }}>AGUA POTABLE</Typography>
                <Typography variant="body2" color="text.secondary">Sistema de Gestión de Agua Potable</Typography>
            </Box>
          </Grid>
          <Grid sx={clases.fondoLogin} >
            <Box sx={{ mb: 4, width: '100%', maxWidth: 200 }}>
              <LogoIcon color="inherit" sx={{ fontSize: '8rem', width: '100%' }} />
            </Box>
            <Typography component="h1" variant="h4" sx={{ fontWeight: 700, mb: 4, letterSpacing: 1 }}>
              BIENVENIDO
            </Typography>
            <Box component="form" sx={{ width: '100%', px: 2 }}>
              <Grid container spacing={2}>
                <Grid >
                  <TextField
                    name="Email"
                    value={usuario.Email}
                    onChange={ingresarValoresMemoria}
                    variant="filled"
                    label="Correo Electrónico"
                    fullWidth slotProps={{ input: { disableUnderline: true, sx: { borderRadius: 2, bgcolor: 'rgba(255,255,255,0.15)', color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' } } }, inputLabel: { sx: { color: 'rgba(255,255,255,0.7)' } } }}
                  />
                </Grid>
                <Grid >
                  <TextField
                    name="Password"
                    value={usuario.Password}
                    onChange={ingresarValoresMemoria}
                    variant="filled"
                    type="password"
                    label="Contraseña"
                    fullWidth slotProps={{ input: { disableUnderline: true, sx: { borderRadius: 2, bgcolor: 'rgba(255,255,255,0.15)', color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' } } }, inputLabel: { sx: { color: 'rgba(255,255,255,0.7)' } } }}
                  />
                </Grid>
              </Grid>
              <Button
                type="submit"
                onClick={loginUsuarioBoton}
                fullWidth
                variant="contained"
                size="large"
                sx={{
                  mt: 4,
                  bgcolor: 'white',
                  color: 'primary.main',
                  fontWeight: 'bold',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' }
                }}
              >
                INGRESAR
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Login;
